import styles from './menu.module.scss';

const Toggler = ({ isOpen, onToggle }) => {
	const className = isOpen ? styles.togglerClose : styles.toggler;

	return (
		<button
			className={className}
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				onToggle();
			}}
			aria-label='Toggle menu'
		/>
	);
};

export default Toggler;
